module.exports = __webpack_public_path__ + "img/envelope-confetti.e63a7143.svg";